import interceptor from '@/common/interceptor/interceptor';
import type { TelemetryVital } from '@/apis/telemetry';

/** A user's saved Sensor modal choices; mirrors `SensorModalPreferencesSerializer`. */
export interface SensorModalPreferences {
  charts: TelemetryVital[];
  show_events: boolean;
}

interface Envelope<T> {
  data: { data: T };
}

const PATH = '/preferences/sensor-modal/';

/** Fetches the logged-in user's Sensor modal preferences for the current workspace, or the defaults. */
export const fetchSensorModalPreferences =
  async (): Promise<SensorModalPreferences> => {
    const response = await interceptor.axiosGet('Get', PATH);
    // The interceptor resolves only 2xx responses, whose body is always CustomResponse's envelope.
    return (response.data as Envelope<SensorModalPreferences>).data.data;
  };

/** Saves only the fields given and returns the full saved preferences. */
export const updateSensorModalPreferences = async (
  changes: Partial<SensorModalPreferences>
): Promise<SensorModalPreferences> => {
  const response = await interceptor.axiosPost('Patch', PATH, changes);
  // The interceptor resolves only 2xx responses, whose body is always CustomResponse's envelope.
  return (response.data as Envelope<SensorModalPreferences>).data.data;
};
